import { Navigate } from "react-router-dom";

/**
 * Role-based route guard.
 * Wraps a route and redirects to /dashboard if the logged-in user's
 * role is not in the allowed `roles` list.
 *
 * Usage:
 *   <Route path="/erm" element={<RoleRoute roles={["Admin"]}><EReplyMarking /></RoleRoute>} />
 */
function RoleRoute({ children, roles }) {
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  // If no roles are specified, allow everyone (public within auth)
  if (!roles || roles.length === 0) {
    return children;
  }

  // If user has a valid token but role hasn't loaded yet, allow rendering
  // (the async validateToken will set the role shortly)
  if (!role && token) {
    return children;
  }

  // If the user's role is not in the allowed list, redirect to dashboard
  if (!role || !roles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default RoleRoute;
